export const COLOR_SCHEMES = {
    default: {
        PMD: '#FFBE00',
        Organic: '#18a44c',
        Paper: '#4084f4',
        Residual: '#757D8A',
    },
    Belgium: {
        PMD: '#4084f4',
        Organic: '#18a44c',
        Paper: '#ffcc14',
        Residual: '#f05c0c',
    },

};

export function getColorScheme(bins, binTypes) {
    if (!bins || bins.length === 0) return COLOR_SCHEMES.default;

    const counts = {};
    bins.forEach((binId) => {
        const country = binTypes?.[binId]?.country;
        if (country) counts[country] = (counts[country] || 0) + 1;
    });

    const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
    const majorityCountry = sorted.length > 0 ? sorted[0][0] : null;

    return COLOR_SCHEMES[majorityCountry] || COLOR_SCHEMES.default;
}

/**
 * Some charts (e.g. contamination-rate-over-time views) intentionally use
 * the OPPOSITE palette from the rest of the dashboard: Belgian bins render
 * with the default palette, and default/unspecified-country bins render
 * with the Belgium palette. Any other named country scheme (once added)
 * passes through unswapped, since no inversion has been defined for it yet.
 */
export function getInvertedColorScheme(bins, binTypes) {
    const scheme = getColorScheme(bins, binTypes);
    if (scheme === COLOR_SCHEMES.Belgium) return COLOR_SCHEMES.default;
    if (scheme === COLOR_SCHEMES.default) return COLOR_SCHEMES.Belgium;
    return scheme;
}